import { render, staticRenderFns } from "./tableusers.vue?vue&type=template&id=6c58ab8e&scoped=true&"
import script from "./tableusers.vue?vue&type=script&lang=js&"
export * from "./tableusers.vue?vue&type=script&lang=js&"
import style0 from "./tableusers.vue?vue&type=style&index=0&id=6c58ab8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58ab8e",
  null
  
)

component.options.__file = "tableusers.vue"
export default component.exports